// Links the editor offers under "Built-in" that are not a page on the
// site. Stored as a token and turned into the real URL by the server
// (App\Support\Website\SiteLinks) when a page is rendered — keep the
// token identical in both places.

export const REPORT_ISSUE_LINK = 'trailsiq:report';

// The resolved shape: app.trailsiq.com/report?org=…&report=1 (or /go,
// the app's newer address — both are TrailsIQ Go). It must
// open in the SAME tab — a phone hands a tapped link to the installed
// Report app, and a new tab is not a tap on a link.
// The org's own page in the app (?org=… with no report=1, the
// footer's TrailsIQ Go icon) is the same kind of link for the same
// reason.
export function isReportAppLink(href) {
    return /^https?:\/\/[^/]+\/(?:report|go)\?(?:[^#]*&)?(?:report=1|org=[^&#]+)(?:&|#|$)/i.test(String(href ?? ''))
        || href === REPORT_ISSUE_LINK;
}

// Whether a link leaves the organization's own site, judged the way
// App\Support\Website\ExternalLinks judges it on save. `hosts` are the
// org's own (TrailsIQ, its custom domain). Below the plan that allows
// outside links the server refuses a NEW one; the editor says so first.
export function isExternalHref(href, hosts) {
    const h = String(href || '').trim();
    if (!h || h.startsWith('#') || h.startsWith('?') || (h.startsWith('/') && !h.startsWith('//'))) return false;
    if (/^(mailto|tel|sms|trailsiq):/i.test(h)) return false;
    const url = h.startsWith('//') ? `https:${h}` : (/^[a-z][a-z0-9+.-]*:/i.test(h) ? h : `https://${h}`);
    let host = '';
    try { host = new URL(url).hostname.toLowerCase().replace(/^www\./, ''); } catch { return true; }
    if (!host) return true;
    return !(hosts || []).some((own) => host === own || host.endsWith(`.${own}`));
}
